import useTranslator from '../../../utilities/hooks/useTranslator';
import useSafeHistory from '../../../utilities/hooks/useSafeHistory';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';

export interface CancelDialogProps {
  openInfo: {open: boolean} | undefined;
  setOpenInfo: (openInfo: {open: boolean} | undefined) => void;
}

const CancelDialogDict = {
  cancelDialogTitle: { en: 'Cancel Update ?', fr: `Annuler la modification ?` },
  cancelDialogMessage: { en: 'You will loose the changes you did to specialty. Do you agree ?', 
                         fr: `Vous perdrez les changements effectués sur la spécialité. Êtes-vous d'accord ?` },
  cancelDialogYes: { en: 'YES', fr: 'OUI' },
  cancelDialogNo: { en: 'NO', fr: 'NON' },
};

const CancelDialog = (props: CancelDialogProps) => {
  const translate = useTranslator();
  const history = useSafeHistory();

  const cancelDialogYes = () => {
    history.goBack()
  }
  const cancelDialogNo = () => {
    props.setOpenInfo({ open: false });
  };

  return (
    <Dialog fullWidth onClose={() => {}} open={!!props.openInfo && props.openInfo.open} keepMounted>
      <DialogTitle data-cy="CancelDialogTitle">{translate(CancelDialogDict.cancelDialogTitle)}</DialogTitle>
      <DialogContent >
        <DialogContentText data-cy="CancelDialogMessage">
          {translate(CancelDialogDict.cancelDialogMessage)}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={cancelDialogNo} data-cy="CancelDialogNoAction">
          {translate(CancelDialogDict.cancelDialogNo)}
        </Button>
        <Button onClick={cancelDialogYes} data-cy="CancelDialogYesAction">
          {translate(CancelDialogDict.cancelDialogYes)}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CancelDialog;
